import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueProgressBar from "vue-progressbar";
import { sync } from "vuex-router-sync";

/* eslint-disable-next-line no-unused-vars */
import normalize from "modern-normalize";
import i18n from "./i18n";

sync(store, router);

Vue.use(VueProgressBar, {
  color: "rgb(0, 158, 217)",
  failedColor: "red",
  height: "2px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300
  }
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
